import { Component, ElementRef, ViewChild } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { LayoutService } from "./service/app.layout.service";
import { AuthService } from '../core/auth/auth.service';
import { Router } from '@angular/router';
import { DashboardService } from '../modules/dashboard/dashboard.service';

@Component({
    selector: 'app-topbar',
    templateUrl: './app.topbar.component.html'
})
export class AppTopBarComponent {

    items!: MenuItem[];
    userFullName: string;

    @ViewChild('menubutton') menuButton!: ElementRef;

    @ViewChild('topbarmenubutton') topbarMenuButton!: ElementRef;

    @ViewChild('topbarmenu') menu!: ElementRef;
    

    constructor(public layoutService: LayoutService,public _authService:AuthService,private _router: Router, private dashboardService: DashboardService) {
        this.userFullName = this._authService.getLoginUser()?.FullName?.trim() || 'Admin Portal';
    }

    logout(){
        // Sign out
        localStorage.clear();
        this._router.navigate(['/auth/login']);
        sessionStorage.clear();
        
    } 

}
